import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface CepPlacesApiResponse {
  zipCode: string;
  uf: string;
  cityName: string;
  ibgeCode: string;
  streetName?: string;
  district?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CepPlacesService {

  constructor(private readonly httpClient: HttpClient) { }

  consultar(cep: string): Observable<CepPlacesApiResponse | null> {
    return this.httpClient.get<CepPlacesApiResponse>(`/apiconnect/places/v3/cities?zipCode=${cep}`).pipe(
      catchError(err => {
        if (err.status === 404) {
          return of(null);
        }
        throw err;
      })
    );
  }
}